import Contact from 'components/Contact';
import { Layout } from 'components/Layout/Layout';
import withApollo from 'lib/apollo';
import * as React from 'react';

function ContactPage() {
  return (
    <Layout title="Contact">
      <Contact />
    </Layout>
  );
}

export default withApollo(ContactPage);
